<template>
  <div>
    <div>
      <v-card class="px-4" flat>
        <v-layout wrap v-if="isUsingSelectEntireEducationOrCertification" mt-2>
          <v-flex xs12>
            <select-entire-education-or-certification :index="index" :isEducationNotCertification="true" :profile="profile" :isFromToken="isFromToken" @setIsUsingSelectEntireEducationOrCertification="setIsUsingSelectEntireEducationOrCertification"/>
          </v-flex>
        </v-layout>
        <v-layout v-else wrap mb-6 pt-6>
          <v-flex xs7>
            <v-btn @click="isUsingSelectEntireEducationOrCertification = true" small class="primary white--text">
              <v-icon small class="mr-2">mdi-select-drag</v-icon>{{ $t('a') }}
            </v-btn>
          </v-flex>
          <v-flex xs5>
            <v-layout wrap>
              <v-flex style="padding-top: 6px">
                <v-btn @click="convertEducationToCertification" x-small outlined>
                  <v-icon x-small class="mr-2">mdi-sync</v-icon>
                  {{ $t('convert') }}
                </v-btn>
              </v-flex>
              <v-flex text-end>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn fab @click="removeEducation" x-small elevation="0" v-bind="attrs" v-on="on">
                      <v-icon small>mdi-delete</v-icon>
                    </v-btn>
                  </template>
                  <small>{{ $t('deleteTooltip') }}</small>
                </v-tooltip>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 mt-6>
            <v-layout wrap justify-space-between>
              <v-flex xs5>
                <v-text-field v-model="profile.educations[index].startYear" dense outlined :label="$t('2')"/>
              </v-flex>
              <v-flex xs5>
                <v-text-field v-model="profile.educations[index].endYear" dense outlined :label="$t('3')"/>
              </v-flex>
            </v-layout>
            <v-layout wrap justify-space-between>
              <v-flex xs12>
                <v-text-field v-model="profile.educations[index].institute" dense outlined :label="$t('4')"/>
              </v-flex>
            </v-layout>
            <v-layout wrap justify-space-between>
              <v-flex xs12>
                <v-text-field v-model="profile.educations[index].description" dense outlined :label="$t('5')"/>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card>
    </div>
  </div>
</template>

<script>
import SelectEntireEducationOrCertification from '@/components/profile/SelectEntireEducationOrCertification.vue';

export default {
  components: {
    SelectEntireEducationOrCertification
  },
  props: {
    profile: Object,
    isOcrResultsLoaded: Boolean,
    index: Number,
    isFromToken: Boolean
  },
  data: () => ({
    isUsingSelectEntireEducationOrCertification: false
  }),
  methods: {
    removeEducation() {
      this.profile.educations.splice(this.index, 1);
      const educationsLength = this.profile.educations.length
      if (educationsLength > 0) {
        if (this.index > 0) this.$emit('goToEditPreviousItem')
      } else {
        this.$emit('goBackToMainForm', { idOfElementToScrollTo: 'view-educations', idOfElementToBlink: 'view-educations', blinkColor: 'red', additionalPixels: -300 })
      }
    },
    convertEducationToCertification() {
      this.profile.certifications.push(JSON.parse(JSON.stringify(this.profile.educations[this.index])))
      this.profile.educations.splice(this.index, 1);
      this.$emit('setFieldPath', { fieldPath: ['certifications', this.profile.certifications.length-1], savedScrollEltId: `view-certifications-${this.profile.certifications.length-1}` })
      this.$emit('updateProfileAndCreateDossier', { isOnlyToUpdateProfile: true })
      this.$emit('showIsSavingIconAFewSeconds')
    },
    setIsUsingSelectEntireEducationOrCertification(data) {
      this.isUsingSelectEntireEducationOrCertification = data.isUsingSelectEntireEducationOrCertification
    }
  },
  watch: {
    isUsingSelectEntireEducationOrCertification: {
      handler() {
        this.$emit('passIsUsingSelectEntireEducationOrCertification', { isUsingSelectEntireEducationOrCertification: this.isUsingSelectEntireEducationOrCertification })
      }
    },
  }
}
</script>


<i18n>
{
  "fr": {
    "a": "Extraire tout le diplôme d'un seul coup",
    "1": "Diplôme",
    "2": "Année de début",
    "3": "Année de fin",
    "4": "Institut",
    "5": "Description",
    "6": "Ajouter un diplôme",
    "convert": "Convertir en certification",
    "deleteTooltip": "Supprimer le diplôme"
  },
  "en": {
    "a": "Extract the entire diploma at once",
    "1": "Diploma",
    "2": "Start year",
    "3": "End year",
    "4": "Institute",
    "5": "Description",
    "6": "Add a diploma",
    "convert": "Convert to certification",
    "deleteTooltip": "Delete the diploma"
  }
}
</i18n>